import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate } from 'src/utils/date';
import { LabelBodyProps } from './RunLabelBody';

export const NorlabLabelBody: React.FC<LabelBodyProps> = ({ product }) => {
  const { t } = useTranslation();
  return (
    <>
      <p>
        <label>{t('product.norlab')}:</label>
        <span>{product.norlabNo}</span>
      </p>
      {product.lotNo && (
        <p>
          <label>{t('product.lotNo')}: </label>
          <span>{product.lotNo}</span>
        </p>
      )}
      <p>
        <label>{t('product.runNo')}: </label>
        <span>{product.runNo}</span>
      </p>
      <p>
        <label>{t('runSystem.singular')}: </label>
      </p>
      <p>
        <span>{product.runSystem.name}</span>
      </p>
      <p>
        <label>{t('grade.singular')}: </label>
        <span>{product.grade.name}</span>
      </p>
      <p>
        <label>{t('props.date')}: </label>
        <span>{formatDate(product.norlabDate)}</span>
      </p>
      <textarea />
    </>
  );
};
